module.exports = __webpack_public_path__ + "img/generika_logo.25c64f3c.jpg";